import { render, staticRenderFns } from "./CssVar.vue?vue&type=template&id=05502540&"
import script from "./CssVar.vue?vue&type=script&lang=js&"
export * from "./CssVar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports